import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { proposalMutationScopeId } from '@/api/mutations/proposals/proposalMutationScope';
import proposalKeys from '@/api/queries/proposal/keyFactor';
import { graphql } from '@/gql';
import {
  SetProposalContentSectionInput,
  SetProposalContentSectionMutation,
} from '@/gql/graphql';

const SET_PROPOSAL_CONTENT_SECTION_MUTATION = graphql(`
  mutation SetProposalContentSection($input: SetProposalContentSectionInput!) {
    setProposalContentSection(input: $input) {
      id
    }
  }
`);

const useSetProposalContentSection = (args?: {
  proposalId?: string;
  options?: UseMutationOptions<
    SetProposalContentSectionMutation,
    unknown,
    SetProposalContentSectionInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};

  return useMutation({
    mutationFn: (input: SetProposalContentSectionInput) => {
      return gqlClient.request(SET_PROPOSAL_CONTENT_SECTION_MUTATION, {
        input,
      });
    },
    scope: args?.proposalId
      ? { id: proposalMutationScopeId(args.proposalId) }
      : undefined,
    onSuccess: (data, variables, context) => {
      if (args?.proposalId) {
        void queryClient.invalidateQueries({
          queryKey: proposalKeys.proposal(args.proposalId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useSetProposalContentSection;
